export default {
  noDataMessage: 'No data found',
};
